import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";

// Initialize i18n
import i18n from "./i18n/index.js";
// Initialize whitelabel service
import whitelabelService from "./services/whitelabelService.js";
// Initialize SVG preloader service
import svgPreloader from "./services/svgPreloader.js";
// Initialize GTM service
import gtmService from "./services/gtmService.js";

//import { useI18n } from '@/composables/useI18n.js'
//const { switchLanguage } = useI18n()

// Initialize whitelabel configuration on app start
whitelabelService.reloadConfiguration();


// Make whitelabel service globally available for i18n
if (typeof window !== 'undefined') {
  window.whitelabelService = whitelabelService;
}

// Preload all SVG icons to prevent pop-in effects
svgPreloader.preloadAllIcons().then(() => {
}).catch(err => {
  console.warn('Some SVG icons failed to preload:', err);
});

// Initialize GTM service
setTimeout(() => {
  gtmService.initialize();
  
  // Track initial whitelabel brand
  const currentBrand = whitelabelService.getBrandName();
  gtmService.trackWhitelabelBrand(currentBrand);
}, 500);

const app = createApp(App);

// Watch for route changes to reload whitelabel configuration
router.afterEach((to) => {
  // Reload whitelabel configuration when path changes
  whitelabelService.reloadConfiguration();

  // Track page views with GTM
  // Small delay to ensure GTM is ready
  setTimeout(() => {
    gtmService.trackPageView(to.path, to.name);
  }, 501);
});

app.use(router).use(i18n).mount("#app");
